module.exports = __webpack_public_path__ + "img/project_completed.a7f90076.svg";